import React from "react";
import { Locale } from "@travellocal/utils";
import { Link } from "../../atoms/Link/Link";
import "./TrustLink.scss";

export const TrustLink = ({
  locale,
  className = "link-is-teal",
}: {
  locale: Locale;
  className?: string;
}) => {
  switch (locale) {
    case "en":
      return (
        <>
          <Link href="https://www.asta.org/" className={className}>
            ASTA
          </Link>
        </>
      );
    case "en-gb":
      return (
        <>
          <Link href="https://www.abta.com/" className={className}>
            ABTA
          </Link>
        </>
      );
    case "de":
      return <></>;
    default:
      return null;
  }
};
